<template>
    <el-container>
        <el-header class="topbar-box">
            <topbar></topbar>
        </el-header>
        <el-container style="width:100%;height:90%;">
            <sidebar></sidebar>
            <el-main class="loading-area" style="height:100%;overflow-x:hidden;">
                <vTags></vTags>
                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import store from '../store/store'
    import topbar from '../components/topbar';
    import sidebar from '../components/sidebar';
    import vTags from '../components/Tags.vue';

    export default {
        name: 'home',
        data() {
            return {
                objMenu: ''
            }
        },
        components: {
            sidebar,
            topbar,
            vTags
        },
        created:function(){
            
        }
    }
</script>
<style lang="scss">
    html, body, .el-container {width: 100%;height: 100%;overflow-x: hidden;}

    * { margin: 0; padding: 0;}
    .loading-area{background:$main-bg;}
    .el-main {padding: 0 !important;position: relative;}
    .el-header {padding: 0 !important;height: 0;}
    .topbar-box {height: 40px !important;padding: 0;background: $top-bg;}
    .fade-enter-active,.fade-leave-active {transition: all .3s ease;}
    .fade-enter, .fade-leave-to { transform: translateX(10px);opacity: 0;}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue